export const MAPPING_TYPE = {
	ACRISS: "custom_acriss",
	CATEGORY: "custom_categories",
}